import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subject, takeUntil } from 'rxjs';
import { PopupPreviewImageComponent } from 'src/app/modules/shared/popup-preview-image/popup-preview-image.component';
import { HeaderService } from '../../header/header.service';

@Component({
  selector: 'app-fbm-order-poduct-info',
  templateUrl: './fbm-order-poduct-info.component.html',
  styleUrls: ['./fbm-order-poduct-info.component.scss']
})
export class FbmOrderPoductInfoComponent implements OnInit,OnDestroy {
  @Input() item: any;
  accountType: string;
  asinLink;
  skuLink;
  store;
  private destroy$ = new Subject<void>();

  constructor(private dialog: MatDialog, private headerService:HeaderService) { 
    this.headerService.accountStore.pipe(takeUntil(this.destroy$)).subscribe((res:any)=>{
      this.store=res;
    })
  }

  ngOnInit(): void {
    this.initializeComponent();
  }
  
  initializeComponent() {
    const image = this.item.image;
    this.item.image = image
      ? image.replace(
        "http://ecx.images-amazon.com/",
        "https://m.media-amazon.com/"
      )
      : "assets/images/No_image.png";

    this.accountType = this.item?.accountType || "";
    this.accountType = this.accountType.toLowerCase();
    this.setLink();
  }

  setLink(id?){
    let baseLink='https://amazon.com/dp/';
    if(this.accountType == 'amazon'){
      switch (id) {
        case 'A2EUQ1WTGCTBG2':
          baseLink="https://amazon.ca/dp/";
        break;            
        case 'A1AM78C64UM0Y8':
          baseLink="https://amazon.com.mx/dp/";
        break;
        case 'ATVPDKIKX0DER': 
        baseLink="https://amazon.com/dp/";
        break
        case 'A1F83G8C2ARO7P': 
        baseLink="https://amazon..co.uk/dp/";
        break
        case 'A1RKKUPIHCS9HS': 
        baseLink="https://amazon.es/dp/";
        break
        case 'A13V1IB3VIYZZH': 
        baseLink="https://amazon.fr/dp/";
        break
        case 'AMEN7PMS3EDWL': 
        baseLink="https://amazon.be/dp/";
        break
        case 'A1805IZSGTT6HS': 
        baseLink="https://amazon.nl/dp/";
        break
        case 'A1PA6795UKMFR9': 
        baseLink="https://amazon.de/dp/";
        break
        case 'APJ6JRA9NG5V4': 
        baseLink="https://amazon.it/dp/";
        break
        case 'A2NODRKZP88ZB9': 
        baseLink="https://amazon.se/dp/";
        break
        case 'AE08WJ6YKNBMC': 
        baseLink="https://amazon.com/dp/";
        break
        case 'A1C3SOZRARQ6R3': 
        baseLink="https://amazon.pl/dp/";
        break
        case 'ARBP9OOSHTCHU': 
        baseLink="https://amazon.eg/dp/";
        break
        case 'A33AVAJ2PDY3EV': 
        baseLink="https://amazon.com.tr/dp/";
        break
        case 'A17E79C6D8DWNP': 
        baseLink="https://amazon.se/dp/";
        break
        case 'A2VIGQ35RCS4UG': 
        baseLink="https://amazon.ae/dp/";
        break
        case 'A21TJRUUN4KGV': 
        baseLink="https://amazon.in/dp/";
        break
      }
      this.asinLink= baseLink + this.item.asin + '?th=1&psc=1';
    }
    if(this.accountType == 'walmart'){
      switch (id) {
        case 'Canada':
          baseLink = 'https://www.walmart.ca/en/ip/';
        break; 
        default:
          baseLink = 'https://www.walmart.com/ip/'; 
        break;
      }
      this.asinLink= baseLink + this.item.asin + '/?selected=true';
    }
    switch (this.accountType) {
      case 'amazon':
        this.skuLink='https://sellercentral.amazon.com/myinventory/inventory?searchTerm=' + this.item.sku;
        break;
      case 'walmart':
        this.skuLink='https://seller.walmart.com/item/list?filters=%257B%2522productOfferId%2522%253A%2522'+ this.item.sku +'%2522%257D';
        break;
      case 'ebay':
        this.skuLink='https://www.ebay.com/sh/lst/active?q_field1=listingId&q_op1=EQUAL&q_value1=' + this.item.sku;
        this.asinLink='https://www.ebay.com/itm/'+ this.item.asin;
        break;
      case 'shopify':
        this.skuLink= this.store+'/admin/products?selectedView=all&query=' + this.item.sku;
        this.asinLink= this.store+'/products/' + this.item.shopifyHandle;
        break;
      case "wish":
        this.skuLink="";
        this.asinLink="";
        break;
      case 'newegg':
        this.skuLink="";
        this.asinLink="";
        break;
      case 'wholesale':
        this.skuLink="";
        this.asinLink="";
        break;
    }
  }

  previewImage(image) {
    this.dialog
      .open(PopupPreviewImageComponent, {
        width: "400px",
        data: {
          url: image,
          title: this.item.title,
        },
      })
      .afterClosed()
      .subscribe((e: any) => {
      });
  }

  titleClicked() {
    if (this.item.detailAction) {
      this.item.detailAction(this.item.data);
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
